module.exports = __webpack_public_path__ + "img/ghcolor.dfed0e7a.png";